import { Input, ViewChildren, QueryList, Injectable, OnInit } from '@angular/core';
import { NgxQueryComponent, ValueInputTemplateDirective } from '@zhongruigroup/ngx-query';
@Injectable()
export abstract class NgxQueryDynamicCustom implements OnInit {
  @Input() ngxQuery: NgxQueryComponent;
  @ViewChildren(ValueInputTemplateDirective)
  set valueInputTemplates(val: QueryList<ValueInputTemplateDirective>) {
    this._valueInputTemplates = val;
  }
  get valueInputTemplates(): QueryList<ValueInputTemplateDirective> {
    return this._valueInputTemplates;
  }
  private _valueInputTemplates: QueryList<ValueInputTemplateDirective>;
  constructor() {}

  ngOnInit() {}

  executeQuery() {
    this.ngxQuery.executeQuery();
  }
}
